<template>
	<el-drawer title="接线中" :visible.sync="show" :modal-append-to-body="false" size="1000px" :before-close="closeBox">
		<el-container class="monitor-detail">
			 <el-aside width="294px" class="monitor-detail__aside">
				 <virtual-list class="list-infinite scroll-touch"
				        :data-key="'sessionId'"
				        :data-sources="lists"
				        :extra-props="{'session_id':session_id}"
				        :estimate-size="91"
				        :data-component="itemComponent"
				        :item-class="'list-item-infinite'"
				        v-on:tobottom="handlerScroll"
				        v-on:toClickItem="toClickItem"
				      >
				      <div slot="footer" class="loading-toobar">
				       <el-button @click="toMore()" type="text" :disabled="!isMore" :loading="loading">{{loading ? '加载中...' : isMore ? '加载更多' : '没有更多数据咯'}}</el-button>
				      </div>
				      </virtual-list>
			 </el-aside>
			<el-container class="monitor-detail__container"  v-if="active_info">
				<el-header>
					<el-descriptions :column="3" size="mini">
					    <el-descriptions-item label="所属渠道">{{getChannelName(active_info.channel)}}</el-descriptions-item>
					    <el-descriptions-item label="会话时长">{{formatSecond(active_info.chatDuration)}}</el-descriptions-item>
					    <el-descriptions-item label="品牌">{{active_info.brandDesc}}</el-descriptions-item>
						<template slot="extra">
						      <el-button  size="mini" @click="toFresh">刷新</el-button>
							  <el-button type="primary" size="mini" @click="toTransferSelf(active_info)" :disabled="userId == this.source.id">介入</el-button>
							  <el-button type="primary" size="mini" @click="onTransfer(active_info)">转接</el-button>
						</template>
					</el-descriptions>
				</el-header>
				<el-main>
					<history-list ref="historyList" :sessionId="active_info.sessionId" :customerId="active_info.customerId" apiUrl="/livechat/msg/list"></history-list>
				</el-main>
			</el-container>
		</el-container>
		<TransfetView v-model="transferViewer.show" :source="transferViewer.source" :parent_source="transferViewer.parent_source" @getList="timeouteGetList"/>
	</el-drawer>
</template>

<script>
	import {channel} from '../../data.js';
	import {formatSecond} from '@/utils/functions';
	import itemComponent from './itemComponent';
	import TransfetView from './transfer';
	import {mapState} from 'vuex';
	export default {
		components:{
			TransfetView
		},
		model:{
			prop:'show',
			event:'close'
			
		},
		computed:{
			...mapState({
				 userId:state => state.user.userInfo.userId
			})
		},
		props:{
			show:{
				default:false,
				type:Boolean
			},
			source:{
				default:''
			}
		},
		watch:{
			show(value){
				if(!value)return;
				this.lists = [];
				this.listQuery.pageNum = 1;
				this.getList()
			}
		},
		data(){
			return {
				itemComponent:itemComponent,
				loading:false,
				lists:[],
				session_id:'',
				isMore:false,
				listQuery:{
					pageNum:1,
					pageSize:10
				},
				total:0,
				active_info:'',
				transferViewer:{
					show:false,
					source:null,
					parent_source:null,
					timer:null
				}
				
			}
		},
		destroyed() {
			if(this.transferViewer.timer){
				clearTimeout(this.transferViewer.timer)
			}
		},
		methods:{
			formatSecond,
			onTransfer(row){
				this.transferViewer = {
					show:true,
					source:row,
					parent_source:this.source,
					timer:null
				}
			},
			toClickItem(source){
				this.active_info = source;
				this.session_id = source.sessionId;
			},
			toTransferSelf(row){
				this.$confirm(`<p>是否介入该会话（转接给本人）？</p>`, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					center: true,
					dangerouslyUseHTMLString: true,
					customClass: "confirm-element-model"
				}).then(() => {
					 this.$api.transformImServiceToSkillGroupItem(`/livechat/forward/request/csr/${row.sessionId}/${this.source.id}/${this.userId}/${row.brandId}/${row.skillGroup}`)
					  .then(res => {
						  if(res.errcode != 0) return;
						  this.closeBox();
					  })
				  })
				  .catch(() => {
				    this.$notify.error("取消介入");
				  });
			},
			toMore(){
				this.listQuery.pageNum++;
				if(this.listQuery.pageNum > this.total){
					this.isMore = false;
					this.listQuery.pageNum = 1;
				}else {
					this.isMore = true;
				}
				this.getList()
			},
			handlerScroll(){
				if(!this.isMore)return;
				this.toMore()
			},
			toFresh(){
				this.$refs.historyList.onLoadData(`/livechat/msg/list`);
			},
			timeouteGetList(){
				this.transferViewer.timer = setTimeout(() => {
					this.listQuery.pageNum = 1;
					this.lists = [];
					this.getList();
				},5 * 1000)
			},
			getList(){
				this.loading = true;
				this.$api.getImImMonitorListsNum(this.source.id,this.listQuery).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.lists = res.list.length > 0 ? this.lists.concat(res.list) : res.list;
					this.total = res.pages;
					this.isMore = res.pages > this.listQuery.pageNum;
					this.active_info = this.lists.length > 0 ? this.lists[0] : '';
					this.session_id = this.active_info?.sessionId
				})
			},
			closeBox(){
				this.$emit('close',false)
			},
			getChannelName(key){
				let index = channel.findIndex(el => el.key == key);
				if(index != -1) return channel[index].name;
				return '--'
			},
		}
	}
</script>

<style lang="scss" scoped>
	.monitor-detail {
		height: 100%;
		::v-deep {
			.el-aside {
				background: #fff;
				padding:  0;
				border-radius: 2px;
				display: block;
				line-height: 32px;
				font-size: 16px;
				color: #2c3e50;
				margin-bottom: 0;
				border-right: 1px solid #d8d8d8;
			}
			
		}
		&__aside {
			.scroll-touch {
				height: 100%;
				overflow: scroll;
			}
			.loading-toobar {
				display: flex;
				justify-content: center;
			}
		}
		&__container {
			::v-deep {
				.el-header {
					width: 100%;
					background-color: #fafafa;
					height: auto !important;
					padding: 20px;
					box-sizing: border-box;
					
				}
				.el-descriptions-item {
					padding-bottom: 0;
				}
				.el-descriptions__body {
					background-color: #fafafa;
				}
			}
		}
	}
</style>